import type { PlatformTenant } from "../../platform/types";
import { sailplotSalesExtensions } from "../../extensions/sailplotSales";
import { coreAssets } from "../coreAssets";

export const sailplotTenant = {
  id: "sailplot",
  domains: ["sailplot.app", "www.sailplot.app", "sandbox.sailplot.app"],
  config: {
    branding: {
      logo: coreAssets.sailplotLogoLight,
      logoDark: coreAssets.sailplotLogoDark,
      compactLogo: coreAssets.sailplotIcon,
      favicon: "/icons/sailplot-icon.svg",
      partnerLogo: coreAssets.heiselLogoDark,
      exportWatermarkLogo: coreAssets.heiselLogoLight,
      exportProductLogo: coreAssets.sailplotLogoLight,
    },
    theme: {
      light: {
        primary: "#FFAA00",
        primaryText: "#171717",
      },
      dark: {
        primary: "#FFAA00",
        primaryText: "#171717",
      },
    },
    objectColors: {
      markColorMode: "yellow",
    },
    links: {
      app: "https://sailplot.app/",
      privacy: "https://sailplot.app/privacy",
      imprint: "https://sailplot.app/imprint",
    },
    ui: {
      help: false,
    },
    pageTitle: "SailPlot",
    storageNamespace: "sailplot-platform-sailplot",
  },
  extensions: sailplotSalesExtensions,
} satisfies PlatformTenant;
